import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { images } from '../../data/offer';
export function FinalCtaSection() {
  return <section className="w-full bg-navy-900 px-5 py-16 sm:py-24" data-id="element-182" data-mp="2ii6gj0zpb6r2">
      <div className="mx-auto max-w-3xl text-center" data-id="element-183" data-mp="2ijr7yhqpy9kp">
        <h2 className="text-balance font-display text-[2.4rem] font-extrabold uppercase leading-[0.98] text-white sm:text-5xl lg:text-6xl" data-id="element-184" data-mp="2dj3jo3tvk6u6">
          Ready to Bring More Structure to Your Low Back Pain Assessments?
        </h2>
        <div className="mt-6 space-y-4 text-lg leading-relaxed text-slate-300" data-id="element-185" data-mp="2mji7b9ub9y0u">
          <p data-id="element-186" data-mp="317w9rjntfkgv">
            You don’t need to keep every assessment detail in your head or search through disconnected resources whenever you want to review a
            clinical concept.
          </p>
          <p data-id="element-187" data-mp="3aanktics4e7z">
            You can build a more organized approach to gathering information, reviewing warning signs, structuring your examination, and
            developing your clinical reasoning.
          </p>
          <p data-id="element-188" data-mp="2225jwkedh74g">I’ve brought these educational resources together into one collection so you can review them at your own pace.</p>
        </div>

        <img src={images.mockup} alt="Low Back Pain Assessment Blueprint collection" className="mx-auto mt-10 w-full max-w-md" data-id="element-189" data-mp="2b1963x8u62n6" />

        <p className="mt-6 font-display text-2xl font-extrabold uppercase text-brand" data-id="element-190" data-mp="2g0m1j6drwi1d">Low Back Pain Assessment Blueprint™</p>
        <p className="mt-1 font-display text-xl font-bold uppercase text-white" data-id="element-191" data-mp="2kyxcxljpv0lp">6 Comprehensive Volumes + 5 Specialized Bonuses</p>
        <p className="mt-3 font-display text-6xl font-black uppercase text-flame" data-id="element-192" data-mp="2oynxv8mkamib">Only $27</p>

        <CtaButton tone="dark" label="Yes! Give Me Access to the Complete Blueprint" sub="One-time payment · Instant digital access · Lifetime access to purchased files" data-id="element-193" data-mp="2tttryuq4b7hh" />
        <p className="mt-3 flex items-center justify-center gap-2 text-sm font-semibold text-slate-300" data-id="element-194" data-mp="38p13ar7w93ur">
          <ShieldCheckIcon className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-195" data-mp="2j0vppz9bfxjm" />
          Protected by a 7-day money-back guarantee
        </p>
      </div>
    </section>;
}